export class Bannerdata {
  bannerData:string;
}
